import { fetchApiWithToken } from '~/api/utils'

export const fetchInvoicePdfBlob = (invoiceId: number) =>
  fetchApiWithToken<{ blob: Blob; filename: string | null }>({
    url: `/v1/invoices/${invoiceId}/pdf`,
    accept: 'application/pdf',
    responseType: 'blobWithDisposition'
  })
